/**
 * @generated SignedSource<<e629b2ba9c15e483fc8cc8652a06ece2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ProposalStatus = "ACTIVE" | "CANCELLED" | "DEFEATED" | "EXECUTED" | "EXPIRED" | "OBJECTION_PERIOD" | "PENDING" | "QUEUED" | "UPDATABLE" | "VETOED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type OnChainProposalRowFragment$data = {
  readonly againstVotes: {
    readonly amount: string;
  };
  readonly ethValue: string;
  readonly forVotes: {
    readonly amount: string;
  };
  readonly number: string;
  readonly proposer: {
    readonly address: {
      readonly resolvedName: {
        readonly address: string;
        readonly " $fragmentSpreads": FragmentRefs<"NounResolvedNameFragment">;
      };
    };
  };
  readonly status: ProposalStatus;
  readonly title: string;
  readonly usdcValue: string;
  readonly voteEndsAt: number;
  readonly voteStartsAt: number;
  readonly " $fragmentSpreads": FragmentRefs<"OnChainProposalRowActivityFragment">;
  readonly " $fragmentType": "OnChainProposalRowFragment";
};
export type OnChainProposalRowFragment$key = {
  readonly " $data"?: OnChainProposalRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"OnChainProposalRowFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OnChainProposalRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ethValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "usdcValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Delegate",
      "kind": "LinkedField",
      "name": "proposer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "address",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ResolvedName",
              "kind": "LinkedField",
              "name": "resolvedName",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NounResolvedNameFragment"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "address",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TokenAmount",
      "kind": "LinkedField",
      "name": "forVotes",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TokenAmount",
      "kind": "LinkedField",
      "name": "againstVotes",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voteStartsAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voteEndsAt",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OnChainProposalRowActivityFragment"
    }
  ],
  "type": "OnChainProposal",
  "abstractKey": null
};
})();

(node as any).hash = "2ab5cc589bb09f90d3b942a80c43aaf2";

export default node;
